import { defineComponent as _defineComponent } from 'vue'
import MaterialIcon from '../common/MaterialIcon.vue';
import { PaginatedResponse } from 'ah-api-gateways';
import { PropType, computed } from 'vue';

interface PageRef {
  name: string;
  pageNumber?: number;
  active?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPagination',
  props: {
  data: {
    type: Object as PropType<Partial<PaginatedResponse<any>>>,
    required: true,
  },
},
  emits: ["set-page"],
  setup(__props, { emit }: { emit: ({
  (e: 'set-page', page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const PAGE_RANGE = 1;

const currentPage = computed(() => props.data.pageNumber || 0);

const totalPages = computed(() => Math.ceil((props.data.total || 0) / (props.data.pageSize || 10)));

const pages = computed(() => {
  const out: PageRef[] = [
    {
      active: currentPage.value === 0,
      pageNumber: 0,
      name: '1',
    },
  ];
  if (currentPage.value > PAGE_RANGE + 1) {
    out.push({
      name: '...',
    });
  }
  for (
    let i = Math.max(1, currentPage.value - PAGE_RANGE);
    i < Math.min(totalPages.value, currentPage.value + PAGE_RANGE + 1);
    i++
  ) {
    out.push({
      pageNumber: i,
      name: `${i + 1}`,
      active: currentPage.value === i,
    });
  }
  if (currentPage.value < totalPages.value - PAGE_RANGE - 2) {
    out.push({
      name: '...',
    });
  }
  if (currentPage.value < totalPages.value - PAGE_RANGE - 1) {
    out.push({
      pageNumber: totalPages.value - 1,
      name: `${totalPages.value}`,
    });
  }

  return out;
});

function setPage(page: number) {
  emit('set-page', page);
}

return { __sfc: true,props, emit, PAGE_RANGE, currentPage, totalPages, pages, setPage, MaterialIcon }
}

})